var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-field',{attrs:{"label":_vm.label}},[_c('b-input',{attrs:{"value":_vm.text,"readonly":"","expanded":"","size":"is-small","type":"text"}}),_c('b-button',{attrs:{"type":"is-primary","size":"is-small","icon-left":_vm.showIcon ? 'link' : null},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }